const defaultFetchPost = err =>
  fetch('/rfpserver/ui-error-logger/log-error', {
    method: 'POST',
    body: JSON.stringify({ err }),
    headers: {
      'Content-type': 'application/json; charset=UTF-8'
    }
  });

export const createErrorLogger = ({
  postError = defaultFetchPost,
  skip403 = false,
  reloadOnChunkLoadError = false
} = {}) => {
  return async (error, isApi, additionalMessage) => {
    let err = {};
    if (error === null || error === undefined) {
      return;
    }
    const errorToSkip = error && error.stack && error.stack.toString();

    if (
      errorToSkip &&
      (errorToSkip.includes('It seems you are still using the old wait option') ||
        (reloadOnChunkLoadError && errorToSkip.includes('ChunkLoadError')))
    ) {
      window.location.reload();
      return;
    }

    if (typeof error === 'string') {
      err = { stack: error };
    } else if (isApi) {
      err = { stack: error };
    } else {
      err = { stack: error.stack };
    }

    err.location = window.location.href;
    if (additionalMessage) {
      err.additionalMessage = additionalMessage;
    }

    const stack = err.stack;
    const stackStr = String(stack ?? '');
    const stackCode = stack && typeof stack === 'object' ? stack.code : undefined;
    const stackMessage = stack && typeof stack === 'object' ? stack.message : undefined;
    if (
      error?.code === 'ECONNABORTED' ||
      stackCode === 'ECONNABORTED' ||
      stackStr.includes('Network Error') ||
      stackMessage === 'Network Error'
    ) {
      console.log('Network Error');
      return;
    }

    if (skip403 && error?.response?.status === 403) {
      return;
    }

    console.error(err);
    if (errorToSkip && (errorToSkip.indexOf('tinymce.js') || errorToSkip.indexOf('bundle.js')) > -1) {
      return;
    }

    await postError(err);
  };
};

export const errorLogger = createErrorLogger();
